<template>
  <div class="app-container">
    <div class="bg-box">
      <div class="box1">
        <el-card class="box1-line">
          <div class="box-title">
            <div class="bar"></div>
            CCER价格走势图-全年
          </div>
          <div
            id="carbaonTradePlate"
            style="width: 100%; height: 520px"
            class="chart"
          ></div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
// import echartsBox from '@/components/echarts'

// import * as echarts from 'echarts'

export default {
  // components: { 'v-chart': echartsBox },
  data() {
    return {
      option: null,
      option1: null,
      cases: [],
      cers: [],
      vers: [],
      ierc: [],
    }
  },
  methods: {
    // async getCCER() {
    //   let res = await getCCER()
    //   if (res.data.code == 200) {
    //     if (Object.prototype.toString.call(res.data.data) == '[object Array]') {
    //       let sData = [],
    //         xDatas = []
    //       res.data.data.forEach((it) => {
    //         sData.push(it.transactionAvgPrice)
    //         xDatas.push(it.transactionDate.substr(0, 10))
    //       })
    //       this.option = {
    //         tooltip: {
    //           trigger: 'axis',
    //           axisPointer: {
    //             type: 'cross',
    //           },
    //         },
    //         toolbox: {
    //           show: true,
    //           feature: {
    //             saveAsImage: {},
    //           },
    //         },
    //         xAxis: {
    //           boundaryGap: false,
    //           data: xDatas,
    //         },
    //         yAxis: {
    //           name: '价格',
    //           type: 'value',
    //           axisLabel: {
    //             formatter: '{value}',
    //           },
    //           axisPointer: {
    //             snap: true,
    //           },
    //         },
    //         series: [
    //           {
    //             name: '价格',
    //             type: 'line',
    //             symbol: 'circle',
    //             symbolSize: 5,
    //             color: '#5BBB7B',
    //             label: {
    //               show: false,
    //               color: '#5BBB7B',
    //             },
    //             data: sData,
    //           },
    //         ],
    //       }

    //       let myChart = echarts.init(
    //         document.getElementById('carbaonTradePlate')
    //       )
    //       myChart.setOption(this.option)
    //     }
    //   }
    // },
    // async getCarbonInclusiveNBCases() {
    //   let res = await getCarbonInclusiveNBCases()
    //   if (res.data.code == 200) {
    //     if (Object.prototype.toString.call(res.data.data) == '[object Array]') {
    //       let sData = [],
    //         xDatas = []
    //       res.data.data.forEach((it) => {
    //         sData.push(it.price)
    //         xDatas.push(it.month)
    //       })
    //       this.option2 = {
    //         tooltip: {
    //           trigger: 'axis',
    //           axisPointer: {
    //             type: 'cross',
    //           },
    //         },
    //         toolbox: {
    //           show: true,
    //           feature: {
    //             saveAsImage: {},
    //           },
    //         },
    //         xAxis: {
    //           boundaryGap: false,
    //           data: xDatas,
    //         },
    //         yAxis: {
    //           name: '价格',
    //           type: 'value',
    //           axisLabel: {
    //             formatter: '{value}',
    //           },
    //           axisPointer: {
    //             snap: true,
    //           },
    //         },
    //         series: [
    //           {
    //             name: '价格',
    //             type: 'line',
    //             // symbol: 'square',
    //             // symbolSize: 10,
    //             color: '#5BBB7B',
    //             label: {
    //               show: false,
    //               color: '#5BBB7B',
    //             },
    //             data: sData,
    //           },
    //         ],
    //       }

    //       let myChart = echarts.init(
    //         document.getElementById('carbaonTradePlate2')
    //       )
    //       myChart.setOption(this.option2)
    //     }
    //   }
    // },
    // async getCarbonNeutralityCases() {
    //   let res = await getCarbonNeutralityCases()
    //   if (res.data.code == 200) {
    //     if (Object.prototype.toString.call(res.data.data) == '[object Array]') {
    //       this.cases = res.data.data
    //       if (res.data.data.length > 3) {
    //         this.$nextTick(() => {
    //           this.animation('scroll1')
    //         })
    //       }
    //     }
    //   }
    // },
    // async getCERS() {
    //   let res = await getCERS()
    //   if (res.data.code == 200) {
    //     if (Object.prototype.toString.call(res.data.data) == '[object Array]') {
    //       this.cers = res.data.data
    //     }
    //   }
    // },
    // async getVERS() {
    //   let res = await getVERS()
    //   if (res.data.code == 200) {
    //     if (Object.prototype.toString.call(res.data.data) == '[object Array]') {
    //       this.vers = res.data.data
    //     }
    //   }
    // },
    // async getIERC() {
    //   let res = await getIERC()
    //   if (res.data.code == 200) {
    //     if (Object.prototype.toString.call(res.data.data) == '[object Array]') {
    //       this.ierc = res.data.data
    //       if (res.data.data.length > 4) {
    //         this.$nextTick(() => {
    //           this.animation('scroll2')
    //         })
    //       }
    //     }
    //   }
    // },
    animation(id) {
      var seamless_container = document.getElementById(id)
      if (seamless_container.children.length > 0) {
        // 限制每个容器的高度
        let seamless_sub = seamless_container.children[0]
        seamless_container.style =
          'max-height: ' + seamless_sub.clientHeight + 'px'
        // 调节滚动速率，使滚动速率不至于过快或过慢
        let scroll_speed = Math.max(
          4,
          Math.ceil(seamless_sub.clientHeight / 35)
        )
        seamless_sub.style =
          'animation: platescroll ' + scroll_speed + 's linear infinite'
        // 复制一份完全相同的列表，实现无缝滚动
        seamless_container.innerHTML += seamless_container.innerHTML
      }

      // 监听鼠标移入事件，暂停动画; 同时鼠标移出，继续动画
      seamless_container.addEventListener('mouseenter', function (event) {
        event.target.classList.add('pause')
      })
      seamless_container.addEventListener('mouseleave', function (event) {
        event.target.classList.remove('pause')
      })
    },
  },
  created() {
    // this.getCCER()
    // this.getCarbonInclusiveNBCases()
    // this.getCarbonNeutralityCases()
    // this.getCERS()
    // this.getVERS()
    // this.getIERC()
  },
  props: {},
  watch: {},
  computed: {},
  mounted() {},
}
</script>
<style>
@keyframes platescroll {
  0% {
    transform: translateY(0);
  } /* 初始位置 */
  100% {
    transform: translateY(-100%); /* 向上滚动 100% 的高度*/
  }
}
</style>
<style scoped lang="scss">
::v-deep {
  .return-btn {
    display: none;
  }
}
.bg-box {
  width: 100%;
  background: #f5f5f5;
  padding: 30px;
}
.box1,
.box2 {
  display: flex;
}
.box2 {
  margin-top: 30px;
  .box-card:nth-child(1) {
    flex: 20% 0 0;
  }
  .box-card:nth-child(2) {
    flex: 20% 0 0;
    margin: 0 30px;
  }
  .box-card:nth-child(3) {
    flex: calc(60% - 60px) 0 0;
  }
}
.box-title {
  font-size: 20px;
  font-weight: 400;
  color: #000000;
  line-height: 30px;
  position: relative;
  padding: 0 0 0 20px;
  background: #fff;
  .bar {
    width: 7px;
    height: 20px;
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -10px;
    background: #204b40;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}
.box1-line {
  flex: 60% 0 0;
  margin-right: 30px;
}
.box1-right {
  flex: 1 0 0;
}
@keyframes scroll {
  0% {
    transform: translateY(0);
  } /* 初始位置 */
  100% {
    transform: translateY(-100%); /* 向上滚动 100% 的高度*/
  }
}
.cases {
  margin-top: 30px;
  height: 280px;
  .ppt {
    font-size: 16px;
    font-weight: 400;
    color: #000000;
    line-height: 26px;
    overflow: hidden;
    .list {
      overflow: hidden;
      &:scroll {
        animation: scroll 10s linear infinite;
      }
    }
    li {
      height: 52px;
      overflow: hidden;
      position: relative;
      border-bottom: 1px solid #dadada;
      padding: 12px 0;
    }
  }
  .time {
    font-size: 14px;
    font-weight: 400;
    color: #999;
    line-height: 26px;
    position: absolute;
    top: 38px;
    right: 0;
  }
}
.list2 {
  height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  .cell {
    font-size: 16px;
    font-weight: 400;
    color: #000000;
    line-height: 24px;
    display: flex;
    padding: 12px 0;
    > div {
      flex: 50% 0 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    > div:nth-child(2) {
      text-align: right;
      padding-left: 10px;
    }
  }
}
.c-table-wrap {
  height: 200px;
  overflow: hidden;
  .c-table.scroll {
    animation: scroll 30s linear infinite;
  }
}
.c-table {
  width: 100%;
  thead {
    height: 48px;
    background: #f5f5f5;
    border-radius: 6px;
    td:nth-child(1) {
      text-align: center;
    }
    td {
      text-align: left;
    }
    .subtitle {
      td {
        color: #999;
        font-size: 12px;
      }
    }
  }
  td:nth-child(1) {
    text-align: center;
    width: 200px;
  }
  td:nth-child(2) {
    width: 200px;
  }
  td:nth-child(3) {
    width: 200px;
  }
//   td:nth-child(4) {
//     width: 13%;
//   }
//   td:nth-child(4) {
//     width: 13%;
//   }
//   td:nth-child(4) {
//     width: 13%;
//   }
  td {
    font-size: 16px;
    font-weight: 400;
    color: #000000;
    line-height: 24px;
    padding: 12px 20px 12px 0;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
